// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EqjD","toggle":"styles_toggle__2G7vy","preview":"styles_preview__zbFJA"};